import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { apiFetch } from './http';

export interface LiveGame {
  game_pk: number;
  away: string;
  home: string;
  away_score: number;
  home_score: number;
  inning: number | null;
  inning_state: string | null;
  detailed_state: string;
}

export interface HistoricalGame {
  game_pk: number;
  away: string;
  home: string;
  away_score: number;
  home_score: number;
  game_date: string | null;
  detailed_state: string;
  away_team_id: number | null;
  home_team_id: number | null;
}

export function useLiveGames() {
  const { getIdToken, user } = useAuth();
  return useQuery<LiveGame[]>({
    queryKey: ['live-games'],
    queryFn: () => apiFetch<LiveGame[]>('/api/games/live', { getIdToken }),
    enabled: Boolean(user),
    refetchInterval: 15_000,
    staleTime: 10_000,
  });
}

export interface HistoricalQuery {
  startDate: string; // YYYY-MM-DD
  endDate: string;
  teamId?: number;
}

export function useHistoricalGames(q: HistoricalQuery) {
  const { getIdToken, user } = useAuth();
  const params = new URLSearchParams({ start_date: q.startDate, end_date: q.endDate });
  if (q.teamId) params.set('team_id', String(q.teamId));
  return useQuery<HistoricalGame[]>({
    queryKey: ['historical-games', q.startDate, q.endDate, q.teamId ?? null],
    queryFn: () => apiFetch<HistoricalGame[]>(`/api/games/historical?${params}`, { getIdToken }),
    enabled: Boolean(user),
    staleTime: 60_000,
  });
}
